<template>
  <div class="nav-page" :class="!showbar?'display-none':''">
    <div class="nav-page-fix">
      <div class="nav-page-line" />
      <div class="nav-page-fix-content flex-row-center match-height">
        <div class="nav-page-fix-content-pre flex-row-center-between flex-1">
          <span v-for="(item, index) in precates" :key="item.id" class=" flex-row-center nav-page-fix-content-item">
            <p class="font-14 cursor tit" :class="selectId == item.id?'sel':''" @click="navigateTap(item)">{{ item.name }}</p>
            <p v-if="index!=3" class="mark font-14">/</p>
          </span>
        </div>
        <div class="nav-page-fix-content-middle position-relative cursor" @click="toHome">
          <img src="@/assets/img/icon-navigation.png">
        </div>
        <div class="nav-page-fix-content-tail flex-row-center-between flex-1">
          <span v-for="(item, index) in tailcates" :key="item.id" class=" flex-row-center nav-page-fix-content-item">
            <p class="font-14 cursor tit" :class="selectId == item.id?'sel':''" @click="navigateTap(item)">{{ item.name }}</p>
            <p v-if="index!=3" class="mark font-14">/</p>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paths: [{
        path: '/news',
        id: 0
      }, {
        path: '/history',
        id: 2
      }, {
        path: '/relation',
        id: 3
      }, {
        path: '/source',
        id: 4
      }, {
        path: '/book',
        id: 5
      }, {
        path: '/webnews',
        id: 6
      }, {
        path: '/commemorate',
        id: 7
      }],
      precates: [{
        index: 0,
        name: '交流公告',
        id: 0,
        path: '/news'
      }, {
        index: 1,
        name: '数字展厅',
        id: 1,
        path: '/libvr'
      }, {
        index: 2,
        name: '光辉事迹',
        id: 2,
        path: '/history'
      }, {
        index: 3,
        name: '关系图谱',
        id: 3,
        path: '/relation'
      }],
      tailcates: [{
        index: 4,
        name: '数字藏品',
        id: 4,
        path: '/source'
      }, {
        index: 5,
        name: '书目推荐',
        id: 5,
        path: '/book'
      }, {
        index: 6,
        name: '追思缅怀',
        id: 6,
        path: '/webnews'
      }, {
        index: 7,
        name: '网上纪念',
        id: 7,
        path: '/commemorate'
      }],
      showbar: true,
      searchKey: '',
      selectId: 999,
      barIndex: 99,
      categorys: [{
        name: '专题活动',
        id: 1
      }, {
        name: '老照片',
        id: 2
      }],
      placeHolder: '输入检索'
    }
  },
  watch: {
    $route(to, from) {
      this.matchRouter(to.fullPath)
    }
  },
  created() {
    this.matchRouter(this.$router.currentRoute.fullPath)
  },
  methods: {
    toHome() {
      if (this.$route.path === '/') {
        return
      }
      this.$router.push({
        path: '/'
      })
    },
    matchRouter(path) {
      this.showbar = true
      if (path.indexOf('/audio') >= 0 || path.indexOf('/libvr') >= 0) {
        this.showbar = false
      }
      const res = this.paths.filter(v => path.indexOf(v.path) >= 0)
      if (res.length) {
        this.selectId = res[0].id
      } else {
        this.selectId = 99
      }
    },
    toLogin() {

    },
    navigateTap(val) {
      const { id, path, url } = val
      if (path) {
        this.$router.push({
          path: path
        })
        this.selectId = id
      } else if (url) {
        window.open(url, '__blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-page {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    z-index: 999;
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.7) 100%);
    backdrop-filter: blur(50px);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
  }

  .nav-page-fix {
    width: 100%;
    height: 100%;
    padding: 0 30px;
    background-color: rgba(0, 0, 0, 0);
  }

  .nav-page-fix-content {
    width: 1220px;
    margin: 0 auto;
  }

  .nav-page-fix-content .tail p {
    margin-right: 30px;
    color: #333;
    cursor: pointer;
  }

  .nav-page-fix-content .tail p.sel {
    color: brown;
    font-weight: bold;
  }

  .nav-page-fix-content-search{
    width: 250px;
    height: 38px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 0 10px;
  }

  .nav-page-fix-content-search input {
    font-size: 14px;
    color: #fff;
    height: 100%;
    flex: 1;
    background-color: rgba(0, 0, 0, 0);
    border: none;
    outline: none;
  }

  .nav-page-fix-content-search input::placeholder{
    color: rgba(255, 255, 255, 0.5) !important;
  }

  .nav-page-fix-content-search img {
    margin-left: 4px;
  }

  .nav-page-fix-content-items p {
    line-height: 36px;
    margin-right: 10px;
    height: 36px;
    padding: 0 10px;
    background: rgba(0, 0, 0, 0);
    border-radius: 5px;
  }

  .nav-page-fix-content-items p:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  .nav-page-fix-content-items p.sel {
    background: rgba(0, 0, 0, 0.1);
  }

  .display-none {
    display: none;
  }

  .nav-page-fix-content-middle {
    width: 360px;
    height: 60px;
    flex-shrink: 0;
  }

  .nav-page-fix-content-tail,
  .nav-page-fix-content-pre {
    padding: 0 20px;
  }

  .nav-page-fix-content-item .mark {
    margin-left: 24px;
    color: rgba(0, 0, 0, 0.1);
  }

  .nav-page-fix-content-item .tit:hover {
    color: #B21F12;
  }

  .nav-page-fix-content-item .tit.sel {
    color: #B21F12;
  }

  .nav-page-fix-content-item p:first-child {
    color: #1a1a1a;
  }

  .nav-page-line {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: #B21F12;
    z-index: 99;
  }

</style>
